import React, { useEffect, useState } from 'react';
import { IconSpinner, Button } from '../../../../components';
import { FormattedMessage } from '../../../../util/reactIntl';
import { getQuickSearchConfig } from './SectionQuickSearch.helpers';
import css from './SectionQuickSearch.css';
import { useCurrentUserGeoData } from '../../../../hooks/useCurrentUserGeoData';
import { createResourceLocatorString } from '../../../../util/routes';
import routeConfiguration from '../../../../routeConfiguration';

export default ({ currentUser, history }) => {
    const [config, setConfig] = useState(null);

    const { userType } = currentUser.attributes.profile.publicData;

    const { loading, geoData: currentLocation } = useCurrentUserGeoData();

    useEffect(() => {
        if (!currentLocation?.origin) return;

        setConfig(getQuickSearchConfig(currentLocation, userType));
    }, [currentLocation, userType]);

    if (loading) {
        return <IconSpinner />;
    }

    return config ? (
        <section className={css.root}>
            <h2 className={css.heading}>
                <FormattedMessage id="SectionQuickSearch.heading" />
            </h2>
            <div className={css.content}>
                {config.options.map(({ search, id, icon }) => (
                    <Button
                        type="button"
                        className={css.quickSearchItem}
                        key={id}
                        onClick={() =>
                            history.push(
                                createResourceLocatorString(
                                    'SearchPage',
                                    routeConfiguration(),
                                    {},
                                    {},
                                    search
                                )
                            )
                        }
                    >
                        {icon}
                        <FormattedMessage id={id} />
                    </Button>
                ))}
            </div>
        </section>
    ) : null;
};
